<template>
  <!-- D: 얼럿은 .l-wrap 바깥에 넣어주세요. -->
  <!-- D: 퍼블에서는 hidden 클래스넣지만 개발에서는 동적으로 불러와야할 듯합니다. -->
  <div
    v-if="data.visible"
    class="alert"
    ref="alertRef"
    tabIndex="-1"
    data-alert
  >
    <template v-if="data.type == 'default'">
      <div class="dialog">
        <div class="dialog-content">
          <div class="text-wrap">
            <p v-html="data.message" class="text"></p>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area type-full">
            <button
              type="button"
              class="c-button type-primary"
              data-alert-close
              @click="confirmAction"
            >
              <span>{{ data.confirmLabel }}</span>
            </button>
            <button
              type="button"
              class="c-button type-secondary"
              data-alert-close
              @click="cancelAction"
            >
              <span>{{ data.cancelLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <template v-if="data.type == 'cancel'">
      <div class="dialog type-large">
        <div class="dialog-content">
          <div class="text-wrap">
            <p class="text">취소 신청 사유를 입력해주세요</p>
            <div class="c-textarea-area type-small">
              <label for="user-message" class="sr-only"
                >취소신청사유 신청란</label
              >
              <textarea
                id="user-message"
                required
                aria-required="true"
                aria-describedby="message-help"
                v-model="data.textarea"
                placeholder="사유를 입력해주세요"
                maxlength="1000"
              ></textarea>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <div class="c-btn-area">
            <button
              type="button"
              class="c-button type-secondary"
              data-alert-close
              @click="clickCancel()"
            >
              <span>{{ data.cancelLabel }}</span>
            </button>
            <button
              type="button"
              class="c-button type-primary"
              data-alert-close
              @click="clickConfirm()"
            >
              <span>{{ data.confirmLabel }}</span>
            </button>
          </div>
        </div>
      </div>
    </template>
    <!-- D: dimmed -->
    <div class="dimmed"></div>
  </div>
</template>

<script setup name="BaseOrderDialog">
import { reactive, onMounted, defineProps, watch, ref, nextTick } from "vue";
import { useBaseOrderDialog } from "@/components/paintpro/composables/useBaseOrderDialog";
const { confirmAction, cancelAction } = useBaseOrderDialog();

const alertRef = ref(null);

const props = defineProps({
  uid: {
    // props로 고유 ID 받기
    type: String,
    required: false,
  },
});

const data = reactive({
  id: "",
  message: "",
  type: "",
  visible: false,
  options: {},
  confirmLabel: "-",
  cancelLabel: "-",
  textarea: "",
});

watch(
  () => data.visible,
  (newValue) => {
    if (newValue) {
      nextTick(() => {
        handleOpen();
      });
    }
  }
);

onMounted(() => {
  const { visible, message, type, options } = useBaseOrderDialog(props.uid);
  data.id = props.uid;
  data.message = message;
  data.type = type;
  data.options = options;
  data.confirmLabel = options.confirmLabel || "확인";
  data.cancelLabel = options.cancelLabel || "취소";
  data.visible = visible;
  data.textarea = "";
});

function clickConfirm() {
  confirmAction(data.textarea);
  data.textarea = "";
}

function clickCancel() {
  cancelAction();
  data.textarea = "";
}

function handleOpen() {
  alertRef.value.focus();
  setupFocusTrap(alertRef.value);
}

function setupFocusTrap(el) {
  // 팝업 내부의 포커스 가능한 요소들
  const focusableElements = el.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  if (focusableElements.length > 0) {
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    el.addEventListener("keydown", function (e) {
      if (e.key === "Tab") {
        if (e.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
          }
        }
      }
    });
  } else {
    el.focus();
  }
}
</script>
